import React from 'react';

import BarPagesChart from '../components/BarPagesChart';



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: number;
	}>;
};



const NumberOfHreflangsChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const categories = data
		.map((item) => ({
			value: item.value,
			label: String(item.value),
			color: '#367be2',
		}))
		.sort((a, b) => a.value - b.value);

	return (
		<BarPagesChart
			categories={categories}
			data={data}
			name="number_of_hreflangs"
		/>
	);
};



export default React.memo(NumberOfHreflangsChart);
